<footer id="footerContainer" class="footer-copyright text-center py-4"> 
    <div id="shareButtons">
        <p class="d-inline">{{ 'footer.socialMediaLabel' | translate }}</p>
        <a href="https://www.fb.me/habana412" target="_blank">
            <img class="ml-1" src="assets/images/icons/facebook-126.png" width="32px" alt="">
        </a>
    </div>
  <p class="footerText mb-2 font-weight-bolder text-center">Habana 412, La Habana, Cuba.&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;+53 5698 5782&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;hello@habana412.com</p>
</footer>